
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("1JnF6", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-US.0218d1f8.js.map
